import type { Components, Theme as MuiTheme } from '@mui/material';

export const alertTheme: Components<MuiTheme> = {
  MuiAlert: {
    variants: [
      {
        props: {
          variant: 'standard',
        },
        style: {
          borderWidth: 1,
          borderStyle: 'solid',
        },
      },
      {
        props: {
          severity: 'error',
        },
        style: ({ theme }) => ({
          borderColor: theme.palette.error.main,
        }),
      },
    ],
  },
};
